import type { SearchResultJob } from '@seek/chalice-types';
import { useEffect } from 'react';

const useGenerateJobRankForAnalytics = ({
  selectedJob,
  pageNumber,
  set,
}: {
  selectedJob: SearchResultJob | undefined;
  pageNumber: number;
  set: Set<number>;
}): number => {
  let selectedJobPosition = selectedJob?.solMetadata?.sectionRank;

  if (selectedJobPosition) {
    set.add(selectedJobPosition);
  }

  useEffect(() => {
    set.clear();
  }, [set, pageNumber]);

  // The auto-opened job item.
  if (set.size === 1) {
    selectedJobPosition = 0;
  }

  return selectedJobPosition;
};

export default useGenerateJobRankForAnalytics;
